import React, { useState } from "react";

import { Input } from "selfly-ui-react";

import './search-field.scss';

export default function SearchField(props) {
    const [value, setValue] = useState("");
    const [delay, setDelay] = useState(null);

    const delayInMilliseconds = 1000;

    function handleChange(e) {
        if(props.disabled === true) {
            return;
        }

        const inputValue = e.currentTarget.value;

        setValue(inputValue);

        if (props.onChange !== undefined && typeof props.onChange === "function") {
            if (delay !== null) {
                clearTimeout(delay);
            }

            if (inputValue === "") {
                props.onChange(inputValue);
            } else {
                setDelay(
                    setTimeout(() => {
                        props.onChange(inputValue);
                    }, delayInMilliseconds)
                );
            }
        }
    }

    return (
        <div className="search-field">
            
            <Input type="text" value={value} onChange={handleChange} placeholder="Enter search keyword" disabled={props.disabled} id="InputSearch" />    
            
        </div>
    );
}
